module.exports = __webpack_public_path__ + "img/cart-check.5765cabc.svg";